import React, { useState } from "react";
import Settings from "../../services/settings.service";
import Translation from "../../services/translation.service";
import ProtectionChannelForm from "./protection-channel-form.component";
import ProtectionChannelOTP from "./protection-channel-otp.component";
import ProgressStepper from "./protection-channel-progress.component";
import ProtectionChannelStatus from "./protection-channel-status.component";
import ProtectionChannelStatusFailure from "./protection-channel-status-failure.component";

export default function ProtectionChannel({ history, status, setStatus }) {
    let prefix = "scr_protection_channel";
    const [activeScreen, setActiveScreen] = useState("OTPScreen");
    const [reporterForm, setReporterForm] = useState({
        number: "",
        otp: ""
    });
    const [stepDetails, setStepDetails] = useState({
        step1: {
            status: "inProgress",
        },
        step2: {
            status: "notVisited",
        },
        step3: {
            status: "notVisited",
        }
    });

    // inProgress, isSuccess, isDone, isFailure, notVisited

    const protectionFlow = (screen) => {
        let content = null;
        switch (screen) {
            case "OTPScreen":
                content = <ProtectionChannelOTP
                    stepDetails={stepDetails}
                    setStepDetails={(e) => { setStepDetails(e) }}
                    setActiveScreen={(e) => { setActiveScreen(e) }}
                    setReporterForm={(e) => { setReporterForm(e) }}
                    history={history}
                />
                break;
            case "ReasonScreen":
                content = <ProtectionChannelForm stepDetails={stepDetails}
                    setStepDetails={(e) => setStepDetails(e)}
                    setActiveScreen={(e) => { setActiveScreen(e) }}
                    setStatus={(e) => { setStatus(e) }}
                    reporterForm={reporterForm} 
                    history={history} />;
                break;
            case "StatusScreen":
                content = <ProtectionChannelStatus
                    setStepDetails={(e) => { setStepDetails(e) }}
                    setActiveScreen={(e) => { setActiveScreen(e) }}
                    status={status} 
                    history={history} />;
                break;
            default:
                content = <ProtectionChannelOTP history={history}/>;
                break;
        }
        return content;
    }
    const languageConvertLink = (link) => {
        if (link && link.includes("%lang%")) {
            return link.replace("%lang%", Translation.activeLang);
        }
    }

    return (
        <>
            {status === "failure" ? (
                <ProtectionChannelStatusFailure   
                    setStepDetails={(e) => { setStepDetails(e) }}
                    setActiveScreen={(e) => { setActiveScreen(e) }}
                    setStatus={(e) => { setStatus(e) }}
                />
            ) : (
                <div className="protection-channel-container">
                    <div className="protection-channel-screens">
                        <div className="protection-channel-intro">
                            <span>{Translation.keys[prefix + "_create_report"]}</span>
                            <div>{Translation.keys[prefix + "_contact_line1"]}
                                <a href={languageConvertLink(Settings.get('contact_us'))} target="_blank" rel="noopener noreferrer">{Translation.keys[prefix + "_contact_us"]}</a>,&nbsp;{Translation.keys[prefix + "_contact_line2"]}</div>
                        </div>
                        {protectionFlow(activeScreen)}
                    </div>
                    <div className="protection-channel-progress">
                        <ProgressStepper info={stepDetails} />
                    </div>
                </div>
            )}
        </>
    )
}